import { z } from 'zod';
import { uuidSchema } from './common';

/** Настройка действует на следующие назначения статуса, без массового переноса истории. */
export const rotationSettingsSchema = z.object({
  enabled: z.boolean(),
  statusIds: z.array(uuidSchema).max(200).refine((ids) => new Set(ids).size === ids.length, 'Статусы не должны повторяться'),
}).strict();

export type RotationSettings = z.infer<typeof rotationSettingsSchema>;

/** Общие напоминания независимы от личной видимости вкладок колокольчика. */
export const rotationReminderSettingsSchema = z.object({
  enabled: z.boolean(),
  daysBefore: z.array(z.number().int().min(1).max(30)).min(1).max(30)
    .refine((days) => new Set(days).size === days.length, 'Дни не должны повторяться'),
}).strict();

export type RotationReminderSettings = z.infer<typeof rotationReminderSettingsSchema>;
export const DEFAULT_ROTATION_REMINDER_SETTINGS: RotationReminderSettings = { enabled: true, daysBefore: [3, 2] };

export const DEFAULT_ROTATION_STATUS_CODES = ['in_car', 'office', 'registered', 'remote'] as const;

/** «Оформился» исторически добавляли вручную, поэтому у него нет общего кода. */
export function isDefaultRotationStatus(status: { code: string; name: string }): boolean {
  return (DEFAULT_ROTATION_STATUS_CODES as readonly string[]).includes(status.code)
    || /^оформил(?:ся|ась)(?:\s*\(\s*-?ась\s*\))?$/iu.test(status.name.trim());
}
